module.exports = __webpack_public_path__ + "static/dagger_of_venom-48514681e21639d155b2ca4de42e6c1c.jpeg";